import PropTypes from 'prop-types';
import * as R from 'ramda';
import React from 'react';
import Alert from 'react-bootstrap/Alert';

const BOOTSTRAP_ALERTS = ['warning', 'danger', 'info', 'success'];

const formatMessages = (messages) => {
    const formatted = {};

    R.forEach((item) => {
        if (!formatted[item.type]) {
            formatted[item.type] = [];
        }
        formatted[item.type].push(item);
    }, messages);

    return formatted;
};

export const Notifications = (props) => {
    const formattedMessages = formatMessages(props.messages);
    let key = -1;

    return (
        <div className="Notifications">
            {' '}
            {R.map(
                (type) =>
                    R.propOr(false, [type], formattedMessages) && (
                        <Alert data-type={type} key={type} variant={type}>
                            {R.map(
                                ({ message }) => (
                                    <p key={key++}>{message}</p>
                                ),
                                formattedMessages[type],
                            )}
                        </Alert>
                    ),
                BOOTSTRAP_ALERTS,
            )}{' '}
        </div>
    );
};

Notifications.propTypes = {
    messages: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.oneOf(BOOTSTRAP_ALERTS),
            message: PropTypes.string,
        }),
    ),
};
